import { render } from "./salesreturnlist.vue?vue&type=template&id=e4bb8598"
import script from "./salesreturnlist.vue?vue&type=script&lang=js"
export * from "./salesreturnlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__